<template>
  <div style="padding: 24px">

    <!-- 数据表格 + 分页 -->
    <el-card shadow="never" style="border-radius:8px">
      <!-- 搜索 & 操作栏 -->
      <div style="margin-bottom: 24px;color:#4E5969;">
        <el-row type="flex" justify="space-between" align="middle">
          <!-- 左侧：批次 + 搜索 + 筛选 + 日期 + 搜索按钮 -->
          <div style="display:flex; gap:12px; align-items:center;">
            <el-input
              v-model="batchNo"
              placeholder="批次编号"
              clearable
              style="width: 200px;"
              @change="handleSearch"
            />
            <el-input
              v-model="search"
              placeholder="搜索链接或书名"
              clearable
              style="width: 200px;"
              @input="debouncedFetchList"
            />
            <el-select
              v-model="filterStatus"
              placeholder="筛选状态"
              clearable
              style="width: 130px;"
              @change="handleSearch"
            >
              <el-option label="未获取" :value="1" />
              <el-option label="已获取" :value="2" />
              <el-option label="失败" :value="3" />
            </el-select>
            <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 270px;"
              @change="handleSearch"
            />
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
            >搜索</el-button>
            <el-button
              icon="el-icon-refresh"
              style="margin:0px 0 0 10px"
              @click="handleReset"
            >重置</el-button>
          </div>
          <!-- 右侧：导出（无弹窗）/ 批量 / 创建 -->
          <div style="display: flex; gap: 12px;">
            <local-file-picker
              button-icon="el-icon-upload"
              button-type="warning"
              button-text="漫剧解析"
              accept=".csv"
              multiple
              @change="handleLocalFileChange"
            />
            <el-button type="danger" @click="clearLink()">清除链接</el-button>
            <el-button type="primary" icon="el-icon-upload2" @click="$refs.files.click()">生成书籍详情<input ref="files" style="display:none;" type="file" multiple accept=".xlsx" @change="uploadPicturesr"></el-button>
            <!-- <el-button type="primary" @click="clearLink()">漫剧解析</el-button> -->
            <el-tooltip content="根据左侧的筛选条件进行导出" placement="top">
              <el-button
                type="success"
                icon="el-icon-download"
                @click="handleExport"
              >导出</el-button>
            </el-tooltip>
            <el-tooltip content="只支持 Excel，每行一个链接。导入后自动批量创建。" placement="top">
              <el-button
                type="warning"
                icon="el-icon-upload2"
                style="margin:0px"
                @click="handleBatchConfirm"
              >EXL批量创建</el-button>
            </el-tooltip>
            <!-- 隐藏文件选择 input，只用来触发 -->
            <input
              ref="batchFileInput"
              type="file"
              style="display:none;"
              accept=".xlsx,.xls"
              @change="handleBatchImport"
            >
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="openCreate"
            >创建</el-button>
          </div>
        </el-row>
      </div>
      <div v-if="loading">
        <div v-for="i in pageSize" :key="i" class="skeleton-row">
          <div v-for="j in 1" :key="j" class="skeleton-cell" />
        </div>
      </div>
      <el-table v-else :data="list" style="width: 100%;border:1px solid #dfe6ec">
        <el-table-column prop="batch_no" label="批次编号" align="center" />
        <el-table-column prop="url" label="链接" align="center">
          <template slot-scope="scope">
            <span
              v-if="scope.row.url"
              class="copyable"
              @click="copyLink(scope.row.url,'链接')"
            >{{ scope.row.url }}</span>
            <span v-else style="color:#ccc;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag :type="getTagType(scope.row.status)">
              <template v-if="scope.row.status === 4">
                正在获取中<span class="loading-dots" />
              </template>
              <template v-else>
                {{ getStatusText(scope.row.status) }}
              </template>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="book_name" label="书名" align="center">
          <template slot-scope="scope">
            <span
              v-if="scope.row.book_name"
              style="cursor:pointer;"
              @click="copyLink(scope.row.book_name,'书名')"
            >{{ scope.row.book_name }}</span>
            <span v-else style="color:#ccc;">暂未获取</span>
          </template>
        </el-table-column>
        <el-table-column prop="source" label="小说来源" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.source">{{ scope.row.source }}</span>
            <span v-else style="color:#ccc;">暂未获取</span>
          </template>
        </el-table-column>
        <el-table-column prop="source" label="小程序名称" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.mini_gram">{{ scope.row.mini_gram }}</span>
            <span v-else style="color:#ccc;">暂未获取</span>
          </template>
        </el-table-column>
        <el-table-column prop="novel_info" label="小说信息" align="center" min-width="250">
          <template slot-scope="scope">
            <span v-if="scope.row.novel_info && scope.row.novel_info.length > 0">{{ scope.row.novel_info[0].word_count_text }} · {{ scope.row.novel_info[0].length_type_text }} · {{ scope.row.novel_info[0].is_end_text }} · {{ scope.row.novel_info[0].platform_text }}</span>
            <span v-else style="color:#ccc;">暂无信息</span>
          </template>
        </el-table-column>
        <el-table-column prop="err_msg" label="番茄ID" align="center" min-width="150">
          <template slot-scope="scope">
            <template v-if="Array.isArray(scope.row.novel_info)">
              <template v-if="scope.row.novel_info.filter(i => i.platform_id === 13).length > 0">
                <template v-if="scope.row.novel_info.filter(i => i.platform_id === 13).length > 1">
                  <!-- 多于1个，显示第一个 + 更多（popover） -->
                  <el-popover placement="top" width="200" trigger="hover">
                    <!-- Popover 内容 -->
                    <div>
                      <el-tag
                        v-for="(item, index) in scope.row.novel_info.filter(i => i.platform_id === 13)"
                        :key="index"
                        type="info"
                        size="mini"
                        style="margin: 2px 4px 2px 0"
                      >
                        {{ item.book_id }}
                      </el-tag>
                    </div>

                    <!-- 显示第一个 + 更多（触发器） -->
                    <span slot="reference" style="cursor: pointer;" @click="copyFanQId(scope.row.novel_info)">
                      <el-tag type="info" size="mini">
                        {{ scope.row.novel_info.filter(i => i.platform_id === 13)[0].book_id }}
                      </el-tag>
                      <el-tag type="primary" size="mini" style="margin-left: 5px;">更多</el-tag>
                    </span>
                  </el-popover>
                </template>

                <template v-else>
                  <!-- 只有一个，直接显示第一个 -->
                  <el-tag type="info" size="mini" style="cursor: pointer;" @click="copyFanQId(scope.row.novel_info)">
                    {{ scope.row.novel_info.filter(i => i.platform_id === 13)[0].book_id }}
                  </el-tag>
                </template>
              </template>
            </template>
          </template>
        </el-table-column>
        <!--        <el-table-column prop="err_msg" label="番茄id" align="center">-->
        <!--          <template slot-scope="scope">-->
        <!--            &lt;!&ndash; 预先过滤出符合条件的数据 &ndash;&gt;-->
        <!--            <template v-if="Array.isArray(scope.row.novel_info)">-->
        <!--              <template v-if="scope.row.novel_info.filter(i => i.platform_id === 13).length > 0">-->
        <!--                &lt;!&ndash; 先提取匹配的列表 &ndash;&gt;-->
        <!--                <template v-if="scope.row.novel_info.filter(i => i.platform_id === 13).length > 1">-->
        <!--                  &lt;!&ndash; 多于1个：用 popover &ndash;&gt;-->
        <!--                  <el-popover placement="top-start" width="200" trigger="hover">-->
        <!--                    <div>-->
        <!--                      <el-tag-->
        <!--                        v-for="(item, index) in scope.row.novel_info.filter(i => i.platform_id === 13)"-->
        <!--                        :key="index"-->
        <!--                        type="info"-->
        <!--                        size="mini"-->
        <!--                        style="margin: 2px 4px 2px 0"-->
        <!--                      >-->
        <!--                        {{ item.book_id }}-->
        <!--                      </el-tag>-->
        <!--                    </div>-->

        <!--                    <el-tag-->
        <!--                      slot="reference"-->
        <!--                      type="primary"-->
        <!--                      size="mini"-->
        <!--                      style="cursor: pointer"-->
        <!--                      @click="copyFanQId(scope.row.novel_info)"-->
        <!--                    >-->
        <!--                      复制 {{-->
        <!--                        scope.row.novel_info.filter(i => i.platform_id === 13).length-->
        <!--                      }} 个-->
        <!--                    </el-tag>-->
        <!--                  </el-popover>-->
        <!--                </template>-->

        <!--                <template v-else>-->
        <!--                  &lt;!&ndash; 只有1个：直接展示 &ndash;&gt;-->
        <!--                  <el-tag type="info" size="mini" style="cursor:pointer;" @click="copyFanQId(scope.row.novel_info)">-->
        <!--                    {{-->
        <!--                      scope.row.novel_info-->
        <!--                        .filter(i => i.platform_id === 13)-->
        <!--                        .map(i => i.book_id)-->
        <!--                        .join(', ')-->
        <!--                    }}-->
        <!--                  </el-tag>-->
        <!--                </template>-->
        <!--              </template>-->
        <!--              &lt;!&ndash; 如果没有一个符合条件的项，什么都不渲染 &ndash;&gt;-->
        <!--            </template>-->
        <!--          </template>-->
        <!--        </el-table-column>-->

        <el-table-column prop="err_msg" label="错误信息" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.err_msg">{{ scope.row.err_msg }}</span>
            <span v-else style="color:#ccc;">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="创建时间" align="center">
          <template slot-scope="scope">{{ formatDate(scope.row.created_at) }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="160">
          <template slot-scope="scope">
            <span class="action-btn" style="color:#165DFF" @click="openUpdate(scope.row)">更新</span>
            <span class="action-btn" style="color:#F53F3F" @click="handleDelete(scope.row.id)">删除</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:16px; text-align:right;">
        <el-pagination
          background
          layout="prev, pager, next, jumper, total"
          :total="total"
          :page-size="pageSize"
          :current-page.sync="page"
          @current-change="fetchList"
        />
      </div>
    </el-card>

    <!-- 创建/更新弹窗 -->
    <el-dialog :title="isUpdate ? '更新链接' : '创建链接'" :visible.sync="dialogVisible">
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="链接" prop="url">
          <el-input
            v-model="form.url"
            @keyup.enter.native="isUpdate ? handleUpdate() : handleAdd()"
          />
          <div style="color:#999;font-size:12px;margin-top:4px;line-height:1.7;">
            {{ isUpdate ? '注意：将会替换掉原来的链接。' : '1. 支持单个链接或空格分割批量添加。\n 2. 链接上传后，最多等待10分钟查看结果。' }}
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="isUpdate ? handleUpdate() : handleAdd()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import LocalFilePicker from '@/components/Upload/LocalFilePicker.vue'

import {
  novelLink,
  createNovelLink,
  updateNovelLink,
  delNovelLink,
  exportNovelLink,
  importMoreLink,
  uploadcertrr, updateAll, importAnalysisPlaylet
} from '@/api/report/adx'

import { uploadFileToCos } from '@/utils/ObjectStorage' // 需要自己封装或者写
import { debounce } from 'lodash'
import { getQcConfig } from '@/api/baiduAD.js'

export default {
  components: { LocalFilePicker },
  data() {
    return {
      batchNo: '',
      search: '',
      filterStatus: null,
      dateRange: [],
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
      form: { url: '', id: null },
      isUpdate: false,
      dialogVisible: false,
      loading: false,
      rules: { url: [{ required: true, message: '请输入链接', trigger: 'blur' }] },
      config: {
        secret_id: 'xxx',
        secret_key: 'xxx',
        bucket: 'xxx-xxx',
        region: 'ap-xxx',
        domain: ''
      }
    }
  },
  watch: {
    page(val) { this.fetchList(val) }
  },
  created() {
    this.debouncedFetchList = debounce(() => this.fetchList(1), 500)
    this.fetchList()
    this.getconfig()
  },
  methods: {
    async getconfig() {
      const res = await getQcConfig()
      this.config = res.data.qcconfig
      console.log(this.config, '这是腾讯云配置')
    },
    handleLocalFileChange(files) {
      if (files.length) {
        Array.from(files).forEach(file => {
          console.log('文件名:', file.name)
          console.log('文件大小:', file.size)
          this.uploadToCosAndSave(file)
          // 这里可以循环调用上传逻辑，比如 uploadFileToCos(file)
        })
      } else {
        console.log('未选择文件')
      }
    },
    uploadToCosAndSave(file) {
      const folderName = 'tiktok_excel' // 你自己想放的文件夹

      uploadFileToCos(file, percent => {
        console.log(`上传进度 ${percent}%`)
      }, folderName, this.config).then(cosKey => {
        // 成功后提示

        // 获取随机文件名部分（Key 里最后一段）
        const cosFileName = cosKey.split('/').pop()

        // 这里拼装你要提交给后台的参数
        const recordParams = {
          file_text: file.name,
          file_name: cosKey,
          cos_file_name: cosFileName
        }
        console.log(recordParams, '这是之后拼装参数到后端')
        // 调用接口把记录存到后台
        this.saveUploadRecord(recordParams)
      }).catch(err => {
        this.$message.error(`${file.name} 上传失败！--${err}`)
      })
    },
    saveUploadRecord(data) {
      console.log(data, '这是上传记录')
      const file_name = this.config.domain + data.file_name
      importAnalysisPlaylet({ file_url: file_name }).then(res => {
        this.$notify({
          title: '导入',
          message: `导入成功，当前的批次编号：${res.data.batch_no}`,
          type: 'success',
          offset: 190
        })
      })
    },
    // EXL批量创建
    handleBatchConfirm() {
      this.$confirm(
        '只支持 Excel，每行一个链接。点击“确定”选择文件，导入后自动批量创建。',
        'EXL批量创建',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false
        }
      ).then(() => {
        // 用户点确定，弹出文件选择框
        this.$refs.batchFileInput.click()
      })
    },
    async handleBatchImport(e) {
      const file = e.target.files[0]
      if (!file || !/\.(xlsx|xls)$/i.test(file.name)) {
        this.$message.warning('只能上传 Excel 文件（.xlsx/.xls）')
        return
      }
      const formData = new FormData()
      formData.append('url_file', file)
      try {
        const res = await importMoreLink(formData)
        const batchNo = res.data?.batch_no || ''
        this.$notify({
          title: '批量创建',
          message: `创建成功，当前的批次编号：${batchNo}`,
          type: 'success',
          offset: 190
        })
        this.fetchList(1)
      } catch {
        this.$message.error('批量创建失败')
      }
      this.$refs.batchFileInput.value = ''
    },

    // 直接用当前过滤条件导出
    async handleExport() {
      try {
        await this.$confirm('确定要根据当前筛选条件导出数据吗？', '导出确认', {
          type: 'info'
        })
        // 用户确认后再导出
        const params = {
          keyword: this.search || '',
          status: this.filterStatus || null,
          start_date: this.dateRange[0] || '',
          end_date: this.dateRange[1] || '',
          batch_no: this.batchNo || ''
        }
        const res = await exportNovelLink(params)
        if (res.data.url) window.open(res.data.url)
        this.$notify({
          title: '导出',
          message: `导出任务已发起，请等待下载 🚀`,
          type: 'success',
          offset: 190
        })
      } catch {
        this.$message.info('取消导出')
      }
    },
    clearLink() {
      this.$confirm('全部清理, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateAll().then(res => {
          console.log(res)
          this.$message.success('修改成功')
          this.fetchList()
        })
      })
    },
    // 打开创建弹窗
    openCreate() {
      this.isUpdate = false
      this.form = { url: '', id: null }
      this.dialogVisible = true
    },
    openUpdate(row) {
      this.isUpdate = true
      this.dialogVisible = true
      this.form = { url: row.url, id: row.id }
    },
    handleSearch() {
      this.page = 1
      this.fetchList(1)
    },
    handleReset() {
      this.batchNo = ''
      this.search = ''
      this.filterStatus = null
      this.dateRange = []
      this.page = 1
      this.fetchList(1)
    },
    async fetchList(page = this.page) {
      this.loading = true
      this.page = page
      const params = {
        page: this.page,
        page_size: this.pageSize,
        keyword: this.search || undefined,
        status: this.filterStatus || undefined,
        start_date: this.dateRange[0] || undefined,
        end_date: this.dateRange[1] || undefined,
        batch_no: this.batchNo || undefined
      }
      try {
        const res = await novelLink(params)
        this.list = res.data?.list || []
        this.total = res.data?.total || 0
      } catch {
        this.$message.error('获取列表失败，请稍后再试')
      }
      this.loading = false
    },
    handleAdd() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        await createNovelLink({ url: this.form.url })
        this.$message.success('创建成功 🚀')
        this.dialogVisible = false
        this.fetchList(1)
      })
    },
    handleUpdate() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        await updateNovelLink({ id: this.form.id, url: this.form.url })
        this.$message.success('更新成功 ✨')
        this.dialogVisible = false
        this.fetchList()
      })
    },
    handleDelete(id) {
      this.$confirm('确定要删除吗？', '提示', { type: 'warning' })
        .then(async() => {
          await delNovelLink({ id })
          this.$message.success('删除成功 🗑️')
          this.fetchList()
        })
        .catch(() => {})
    },
    getStatusText(status) {
      switch (status) {
        case 1: return '未获取'
        case 2: return '已获取'
        case 3: return '失败'
        case 4: return '获取中'
        default: return '未知'
      }
    },
    getTagType(status) {
      switch (status) {
        case 2: return 'success'
        case 3: return 'danger'
        case 4: return 'primary'
        default: return 'info'
      }
    },
    copyLink(link, name) {
      navigator.clipboard.writeText(link).then(() =>
        this.$message.success(`${name}已复制`)
      )
    },
    copyFanQId(val) {
      console.log(val)
      const bookIds = val
        .filter(item => item.platform_id === 13)
        .map(item => item.book_id)
        .filter(Boolean)

      if (bookIds.length === 0) {
        this.$message.warning('没有符合条件的 book_id')
        return
      }

      const textToCopy = bookIds.join(',')

      console.log('将要复制的 book_id:', textToCopy)

      navigator.clipboard.writeText(textToCopy).then(() => {
        this.$message.success('book_id 已复制')
      }).catch(() => {
        this.$message.error('复制失败，请手动复制')
      })
    },
    formatDate(str) {
      if (!str) return ''
      const d = new Date(str)
      const pad = s => String(s).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
             `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
    },
    async uploadPicturesr(e) {
      console.log('e.target.files', e.target.files)
      // eslint-disable-next-line eqeqeq
      const extension = e.target.files[0].name.split('.').slice(-1) == 'xlsx'
      if (!extension) {
        this.$message.error('生成书籍详情只能是xlsx格式!')
        return
      }
      const form = new FormData()
      form.append('url_file', e.target.files[0])
      // const file = e.target.files
      const data = await uploadcertrr(form)
      // this.siminame = e.target.files[0].name
      console.log('data', data.data.batch_no)
      this.$message.success(`生成书籍详情成功编号：${data.data.batch_no}`)
      // this.parameter.private_key_file_path = data.data.path
      // console.log('e', e, e.target.files[0])
      // const fileIfon = e.target.files[0]
    }
  }
}
</script>

<style scoped>
.action-btn {
  cursor: pointer;
  color: #409EFF;
  margin: 0 10px;
  transition: color .2s;
}
.action-btn:hover {
  opacity: .8;
}
.copyable {
  cursor: pointer;
  color: #165dffbf;
  transition: color .2s;
}
.copyable:hover {
  color: #1e80ff;
  text-decoration: underline;
  opacity: .85;
}
.loading-dots {
  display: inline-block;
  width: 18px;
  height: 12px;
  vertical-align: middle;
  margin-bottom: 14px;
  margin-left: -5px;
}
.loading-dots::after {
  content: '';
  display: inline-block;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: #ffa940;
  box-shadow: 6px 0 0 0 #ffa940, 12px 0 0 0 #ffa940;
  animation: loading-bounce 1s infinite linear;
}
@keyframes loading-bounce {
  0%   { box-shadow: 6px 0 0 0 #ffa940, 12px 0 0 0 #ffa940; }
  33%  { box-shadow: 6px -3px 0 0 #ffa940, 12px 0 0 0 #ffa940; }
  66%  { box-shadow: 6px 0 0 0 #ffa940, 12px -3px 0 0 #ffa940; }
  100% { box-shadow: 6px 0 0 0 #ffa940, 12px 0 0 0 #ffa940; }
}

.skeleton-row {
  display: flex;
  margin-bottom: 18px;
}
.skeleton-cell {
  flex: 1;
  height: 32px;
  margin-right: 12px;
  background: linear-gradient(90deg, #f4f4f5 25%, #e9ecef 37%, #f4f4f5 63%);
  background-size: 400% 100%;
  border-radius: 6px;
  animation: skeleton-loading 1.2s ease-in-out infinite;
}
.skeleton-cell:last-child {
  margin-right: 0;
}
@keyframes skeleton-loading {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}
/deep/ .el-table th {
  background: #F5F7FA !important;  /* 换你喜欢的颜色 */
}
</style>
